import { Loader, Avatar as MAvatar } from '@mantine/core';
import {
  useGetSupplierAvatarQuery,
  useGetSupplierRequestMatchAvatarsQuery,
} from '../api';
import { PLACEHOLDER_PROFILE_IMAGE } from '../constants';
import { safeImage } from '../utils';

interface Props {
  supplierId?: string;
  size?: number;
}

export const SupplierAvatar = ({ supplierId, size }: Props) => {
  const { data: avatar, isLoading } = useGetSupplierAvatarQuery(
    supplierId as string,
    { skip: !supplierId }
  );

  if (isLoading) {
    return <Loader size={size} />;
  }

  return (
    <MAvatar
      className="border-2"
      radius="xl"
      size={size}
      src={safeImage(avatar?.image) || PLACEHOLDER_PROFILE_IMAGE}
      alt="supplier avatar"
    />
  );
};

interface SupplierRequestMatchAvatarProps {
  supplierRequestId: string;
  supplierId: string;
  size?: number;
}

export const SupplierRequestMatchAvatar = ({
  supplierRequestId,
  supplierId,
  size,
}: SupplierRequestMatchAvatarProps) => {
  const { data, isLoading } = useGetSupplierRequestMatchAvatarsQuery(
    supplierRequestId,
    {}
  );

  if (isLoading) {
    return <Loader size={size} />;
  }

  return (
    <MAvatar
      className="border-[2px]"
      radius="xl"
      size={size}
      src={
        safeImage((data || {})[supplierId]?.image) || PLACEHOLDER_PROFILE_IMAGE
      }
      alt="supplier avatar"
    />
  );
};
